module.exports = __webpack_public_path__ + "media/assets/icons/medical-icon-bluegray-500-c7082d44d986cd9d13e0edd30293ef5b.svg";